import { themeColors } from '@/theme/colors';
import { Flex, Text } from '@lego/klik-ui';
import type { PropsWithChildren, ReactNode } from 'react';

type Props = PropsWithChildren<{
  title: string;
  actions?: ReactNode;
}>;

/** A titled card that holds one part of the developer dashboard. */
export const DashboardSection = ({ title, actions, children }: Props) => (
  <Flex
    as="section"
    aria-label={title}
    flexDirection="column"
    minWidth={0}
    flex={1}
    minHeight={0}
    overflow="hidden"
    gap={2}
    padding={3}
    borderRadius="8px"
    backgroundColor={themeColors.surface.background.base.default}
  >
    <Flex justifyContent="space-between" alignItems="center">
      <Text fontSize="md" fontWeight="bold">
        {title}
      </Text>
      {actions}
    </Flex>
    <Flex flexDirection="column" gap={2} flex={1} minHeight={0}>
      {children}
    </Flex>
  </Flex>
);
